"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_FOLDER_DEPTH_LIMIT = exports.DEFAULT_FOLDER_RELATIONS = void 0;
// TODO: add contents and invites only if we update the cache accordingly
exports.DEFAULT_FOLDER_RELATIONS = ['mainMedia'];
exports.DEFAULT_FOLDER_DEPTH_LIMIT = 10;
//# sourceMappingURL=session-participants.consts.js.map